import user from "../Models/user"
import global from '../global'

/**
 * Logout function - clears all user data and redirects to login
 * @param {function} navigate - React Router navigate function
 * @param {boolean} clearInvoiceDevice - Whether to also clear invoice device (complete logout)
 */
export const logout = async (navigate, clearInvoiceDevice = false) => {
    try {
        await window.axios.post('/logout')
    } catch (error) {
        // Continue with logout even if API call fails
        console.warn('Logout API call failed:', error)
    } finally {
        // Clear token
        localStorage.removeItem('token')

        // Clear invoice device if requested (complete logout)
        if (clearInvoiceDevice) {
            localStorage.removeItem('invoiceDevice')
            global.invoiceDevice = {}
        }

        // Clear user data
        user.logout()

        // Clear axios headers
        delete window.axios.defaults.headers.common['Authorization']
        delete window.axios.defaults.headers.common['X-Authorization']
        delete window.axios.defaults.headers.common['X-User-Id']

        // Navigate to login
        navigate('/login')
    }
}

export default logout
